export default [
  {
    path: '/gk-spokes/index',
    name: 'Index',
    component: () => import('@/views/gk-spokes/index'),
    meta: {
      title: '高考直通车-车车代言人'
    }
  },
  
]
